<template>
  <div id="app">
    <div id="title_container">
      <!-- <div class="navbar-fixed-top"> -->
      <el-row id="title_row" style="z-index: 100000;">
        <el-col :span="5">
          <div style="height: 60px;width: 290px;">
            <img id="log_img" class="" :src="$t('mes.index_top_nav_log_src')" style="height:100%;width:50%;cursor: pointer;"
              @click="routerTo('/')" />
          </div>
        </el-col>
        <el-col :span="14">
          <ul id="tile_center">
            <li id="index_first_li" @click="routerTo('/')"><a>{{$t('mes.index_top_nav_1')}}</a> </li>

            <li id="index_second_li" @click="openYDDrawer()"><a>{{$t('mes.index_top_nav_2')}}</a></li>

            <li v-if="lang=='zh-CN'" id="index_third_li" @click="openZWDrawer()"><a>{{$t('mes.index_top_nav_3')}}</a></li>
            <!-- <li v-if="lang=='zh-CN'" id="index_four_li" @click="routerTo('/device/p35')"><a>{{$t('mes.index_top_nav_4')}}</a></li> -->
            <li id="index_five_li" @click="routerTo('/qyzx_children')" style="border: none;"><a>{{$t('mes.index_top_nav_5')}}</a></li>
          </ul>
        </el-col>
        <el-col :span="5">
          <!--翻译-->
          <ul id="tile_right">
            <li id="index_six_li" class="" @click="exchangeLauguage('zh')">{{$t('mes.index_top_zh_lang_tips')}}</li>
            <li id="index_seven_li" class="" style="border: none;" @click="exchangeLauguage('en')">{{$t('mes.index_top_en_lang_tips')}}</li>
          </ul>
        </el-col>
      </el-row>

      <div id="yd_device" class="scoll">
        <img src="../static/img/index/top1.png" @click="ydDeviceRouterTo('/device/o12')" />
        <img src="../static/img/index/top2.png" @click="ydDeviceRouterTo('/device/o21')" />
        <img src="../static/img/index/top3.png" @click="ydDeviceRouterTo('/device/o22')" />
        <img src="../static/img/index/top4.png" @click="ydDeviceRouterTo('/device/r700')" />
        <img src="../static/img/index/top5.png" @click="ydDeviceRouterTo('/device/r800')" />
        <img src="../static/img/index/top6.png" @click="ydDeviceRouterTo('/device/f60')" />
        <img src="../static/img/index/top7.png" @click="ydDeviceRouterTo('/device/mm750')" />
      </div>
      <div id="zw_device" class="scoll">
        <img :src="$t('mes.index_top_1')" @click="zwDeviceRouterTo('/device/h18')" />
        <!-- <img :src="$t('mes.index_top_2')" @click="zwDeviceRouterTo('/device/d30')" /> -->
      </div>
      <!-- </div> -->
    </div>
    <!-- <div style="display: flex;" id="luxy"> -->
    <div style="" id="luxy">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <div>
        <div v-if="lang=='zh-CN'">
          <el-row id="footer_div_index" style="background-color: #393939;height: auto;padding-top: 3%;padding-bottom: 3%;">
            <el-col :span="4" :offset="2">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav">
                  <li class="first_li">{{$t('mes.index_bottom_nav_1')}}</li>
                  <li class="other_li"><span @click="routerTo('/device/r800')"> {{$t('mes.index_bottom_nav_1_1')}}</span></li>
                  <li class="other_li"><span @click="routerTo('/device/f60')"> {{$t('mes.index_bottom_nav_1_2')}}</span></li>
                  <li class="other_li"><span @click="routerTo('/device/mm750')"> {{$t('mes.index_bottom_nav_1_3')}}</span></li>
                  <!-- <li class="other_li"><span @click="routerTo('/device/p35')"> P35人脸识别</span></li> -->
                </ul>
              </div>
            </el-col>
            <el-col :span="4">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav">
                  <li class="first_li">{{$t('mes.index_bottom_nav_2')}}</li>
                  <li class="other_li"><span @click="routerTo('/qyzx_children')"> {{$t('mes.index_bottom_nav_2_1')}}</span></li>
                  <li class="other_li"><span @click="routerTo('/qyzx_children/fzlc')"> {{$t('mes.index_bottom_nav_2_2')}}</span></li>
                  <li class="other_li"><span @click="routerTo('/qyzx_children/hzhb')"> {{$t('mes.index_bottom_nav_2_3')}}</span></li>
                  <li class="other_li"><span @click="routerTo('/qyzx_children/hzfs')"> {{$t('mes.index_bottom_nav_2_4')}}</span></li>
                  <li class="other_li"><span @click="routerTo('/qyzx_children/zlrz')"> {{$t('mes.index_bottom_nav_2_5')}}</span></li>
                </ul>
              </div>
            </el-col>
            <el-col :span="4">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav">
                  <li class="first_li">{{$t('mes.index_bottom_nav_3')}} </li>
                  <li class="li_parent">
                    {{$t('mes.index_bottom_nav_3_1')}}
                    <ul class="ul_children">
                      <li class="li_children" @click="routerTo('/device/o21')"><span> O21</span></li>
                      <li class="li_children" style="border: none;" @click="routerTo('/device/o22')">O22</li>
                      <!-- <li class="li_children" style="border: none;" @click="routerTo('/device/o22')">O23</li> -->
                    </ul>
                  </li>
                  <li class="li_parent">{{$t('mes.index_bottom_nav_3_2')}}
                    <ul class="ul_children">
                      <li class="li_children" @click="routerTo('/device/r700')">R700</li>
                      <li class="li_children" style="border: none;" @click="routerTo('/device/r800')">R800</li>
                    </ul>
                  </li>
                  <li class="other_li" style="cursor:default ;">{{$t('mes.index_bottom_nav_3_3')}}&nbsp;&nbsp;&nbsp;<a
                      style="cursor: pointer;" @click="routerTo('/device/f60')">F60</a></li>
                  <li class="other_li" style="cursor: default;">{{$t('mes.index_bottom_nav_3_4')}}&nbsp;&nbsp;&nbsp;<a
                      style="cursor: pointer;" @click="routerTo('/device/mm750')">MM750</a></li>
                </ul>
              </div>
            </el-col>
            <el-col :span="4">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav">
                  <li class="first_li">专网通信 </li>
                  <li class="other_li"><span @click="routerTo('/device/h18')">基站采集</span></li>
                  <!-- <li class="other_li"><span @click="routerTo('/device/d30')">无线信号分析</span></li> -->
                </ul>
              </div>
            </el-col>
            <!-- <el-col :span="4">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav">
                  <li class="first_li">人脸识别</li>
                  <li class="other_li"><span @click="routerTo('/device/p35')">人脸信息采集</span></li>
                </ul>
              </div>
            </el-col> -->
          </el-row>
        </div>
        <div v-else>
          <el-row id="footer_div_index" style="background-color: #393939;height: auto;padding-top: 3%;padding-bottom: 3%;">
            <el-col :span="7" :offset="2">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav_en">
                  <li class="first_li_en">{{$t('mes.index_bottom_nav_1')}}</li>
                  <li class="other_li_en"><span @click="routerTo('/device/r800')"> {{$t('mes.index_bottom_nav_1_1')}}</span></li>
                  <li class="other_li_en"><span @click="routerTo('/device/f60')"> {{$t('mes.index_bottom_nav_1_2')}}</span></li>
                  <li class="other_li_en"><span @click="routerTo('/device/mm750')"> {{$t('mes.index_bottom_nav_1_3')}}</span></li>
                </ul>
              </div>
            </el-col>
            <el-col :span="7">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav_en">
                  <li class="first_li_en">{{$t('mes.index_bottom_nav_2')}}</li>
                  <li class="other_li_en"><span @click="routerTo('/qyzx_children')"> {{$t('mes.index_bottom_nav_2_1')}}</span></li>
                  <li class="other_li_en"><span @click="routerTo('/qyzx_children/fzlc')">
                      {{$t('mes.index_bottom_nav_2_2')}}</span></li>
                  <li class="other_li_en"><span @click="routerTo('/qyzx_children/hzhb')">
                      {{$t('mes.index_bottom_nav_2_3')}}</span></li>
                  <li class="other_li_en"><span @click="routerTo('/qyzx_children/hzfs')">
                      {{$t('mes.index_bottom_nav_2_4')}}</span></li>
                  <li class="other_li_en"><span @click="routerTo('/qyzx_children/zlrz')">
                      {{$t('mes.index_bottom_nav_2_5')}}</span></li>
                </ul>
              </div>
            </el-col>
            <el-col :span="7">
              <div style="text-align: left;height: 100%;padding-bottom: 10%;">
                <ul class="footer_nav_en">
                  <li class="first_li_en">{{$t('mes.index_bottom_nav_3')}} </li>
                  <li class="li_parent_en">
                    {{$t('mes.index_bottom_nav_3_1')}}
                    <ul class="ul_children_en">
                      <li class="li_children_en" @click="routerTo('/device/o21')"><span> O21</span></li>
                      <li class="li_children_en" style="border: none;" @click="routerTo('/device/o22')">O22</li>
                      <!-- <li class="li_children" style="border: none;" @click="routerTo('/device/o22')">O23</li> -->
                    </ul>
                  </li>
                  <li class="li_parent_en">{{$t('mes.index_bottom_nav_3_2')}}
                    <ul class="ul_children_en">
                      <li class="li_children_en" @click="routerTo('/device/r700')">R700</li>
                      <li class="li_children_en" style="border: none;" @click="routerTo('/device/r800')">R800</li>
                    </ul>
                  </li>
                  <li class="other_li_en" style="cursor:default ;">{{$t('mes.index_bottom_nav_3_3')}}&nbsp;&nbsp;&nbsp;<a
                      style="cursor: pointer;" @click="routerTo('/device/f60')">F60</a></li>
                  <li class="other_li_en" style="cursor: default;">{{$t('mes.index_bottom_nav_3_4')}}&nbsp;&nbsp;&nbsp;<a
                      style="cursor: pointer;" @click="routerTo('/device/mm750')">MM750</a></li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row style="background-color: #000;height: auto;">
          <el-col :span="24">
            <div style="display: flex; padding: 5%; padding-left: 10%;padding-right: 10%;background-color: #000000;">
              <div style="width: 30%;">
                <img src="../static/img/index/footer_log.png" />
              </div>
              <div style="width: 70%;display: flex;">
                <div class="info_div" style="width: 50%;text-align: left;">
                  <span>电话：+86 -755-82535133</span><br />
                  <span>传真：+86 -755-82535757</span><br />
                  <span>邮箱：server@simdo.cn </span><br />
                  <span>地址： 深圳市南山区粤海街道海天二路25号深圳湾创业投资大厦39层</span>
                </div>
                <div class="info_div" style="width: 50%;text-align: left;">
                  <span>Phone：+86 -755-82535133</span><br />
                  <span>Fax：+86 -755-82535757</span><br />
                  <span>Email：server@simdo.cn</span><br />
                  <span>Address：39F,Shenzhen Bay Venture Capital Building,No.25,Haitian 2nd Road, Binhai Community,Yuehai Street,Nanshan </span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="24" style="padding-bottom: 1.2%;">
            <span class="index_footer_luokuan" >Copyright©心派科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <a class="index_footer_luokuan" target="_blank" id="record_id" href="https://beian.miit.gov.cn">粤ICP备16090533号</a>
            <span class="index_footer_luokuan" >&nbsp;&nbsp;粤公网安备 44030502000484号</span>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        ydDeviceOpen: false,
        zwDeviceOpen: false,
        lang: this.$i18n.locale,
        content: this.$t('mes.exchange_tip_content'),
        title: this.$t('mes.exchange_tip_title'),
        confirm_btn: this.$t('mes.exchange_tip_confirm_btn'),
        cancel_btn: this.$t('mes.exchange_tip_cancel_btn'),
      }
    },
    methods: {

      routerTo(path) {
        if (this.$route.path == path) {
          return;
        }
        this.$router.push(path);
        var yd = $("#yd_device");
        var zw = $("#zw_device");
        if ($(yd).hasClass('top_To_Bottom')) {
          $(yd).removeClass('top_To_Bottom').addClass("bottom_To_Top");
        }
        if ($(zw).hasClass('top_To_Bottom')) {
          $(zw).removeClass('top_To_Bottom').addClass("bottom_To_Top");
        }
      },
      ydDeviceRouterTo(path) {
        this.routerTo(path);
        $("#yd_device").removeClass('top_To_Bottom').addClass("bottom_To_Top");
      },
      zwDeviceRouterTo(path) {
        this.routerTo(path);
        $("#zw_device").removeClass('top_To_Bottom').addClass("bottom_To_Top");
      },
      openYDDrawer() {
        var orOpen = this.ydDeviceOpen;
        if (orOpen) {
          if ($("#yd_device").hasClass('bottom_To_Top')) {
            $("#yd_device").removeClass('bottom_To_Top').addClass("top_To_Bottom");
          } else
            this.ydDeviceOpen = false
        } else {
          this.ydDeviceOpen = true
        }
      },
      openZWDrawer() {
        var orOpen = this.zwDeviceOpen;
        if (orOpen) {
          if ($("#zw_device").hasClass('bottom_To_Top')) {
            $("#zw_device").removeClass('bottom_To_Top').addClass("top_To_Bottom");
          } else
            this.zwDeviceOpen = false
        } else {
          this.zwDeviceOpen = true
        }
      },
      initAnimation() {
        $('#log_img').addClass('animation-XClass');
        $('#index_first_li').addClass('animationClass');
        setTimeout(function() {
          $('#index_second_li').addClass('animationClass');
        }, 200)
        setTimeout(function() {
          $('#index_third_li').addClass('animationClass');
        }, 400)
        setTimeout(function() {
          $('#index_four_li').addClass('animationClass');
        }, 600)
        setTimeout(function() {
          $('#index_five_li').addClass('animationClass');
        }, 800)

        $('#index_six_li').addClass('animationClass');

        setTimeout(function() {
          $('#index_seven_li').addClass('animationClass');
        }, 200)
      },
      exchangeLauguage(type) {

        // //以下删除  开始
        // if (type == "en") {
        //   this.$alert('Coming soon', '', {
        //     confirmButtonText: "Cancel",
        //     lockScroll: false
        //   });
        //   return;
        // }
        // //结尾
        this.$confirm(this.content, this.title, {
          confirmButtonText: this.confirm_btn,
          cancelButtonText: this.cancel_btn,
          type: 'warning',
          lockScroll: false
        }).then(() => {
          if (type === "zh" && this.lang === 'zh-CN') {
            return;
          }
          if (type === "en" && this.lang === 'en-US') {
            return;
          }

          var yd = $("#yd_device");
          var zw = $("#zw_device");
          if ($(yd).hasClass('top_To_Bottom')) {
            $(yd).removeClass('top_To_Bottom').addClass("bottom_To_Top");
          }
          if ($(zw).hasClass('top_To_Bottom')) {
            $(zw).removeClass('top_To_Bottom').addClass("bottom_To_Top");
          }

          if (this.lang === 'zh-CN') {
            this.lang = 'en-US';
            this.$i18n.locale = this.lang; //关键语句
          } else {
            this.lang = 'zh-CN';
            this.$i18n.locale = this.lang; //关键语句
          }

          // return;
          //改变标题
          document.title = this.$t('mes.title');
          this.content = this.$t('mes.exchange_tip_content');
          this.title = this.$t('mes.exchange_tip_title');
          this.confirm_btn = this.$t('mes.exchange_tip_confirm_btn');
          this.cancel_btn = this.$t('mes.exchange_tip_cancel_btn');
        }).catch(() => {
          //关闭事件
        });
      },

    },
    computed: {
      ydDeviceOpenChange() {
        return this.ydDeviceOpen;
      },
      zwDeviceOpenChange() {
        return this.zwDeviceOpen;
      }
    },
    watch: {
      ydDeviceOpenChange(val, oldVal) {
        if (val) {
          $("#yd_device").removeClass('bottom_To_Top').addClass("top_To_Bottom");
          if ($("#zw_device").hasClass('top_To_Bottom')) {
            this.zwDeviceOpen = false
            $("#zw_device").removeClass('top_To_Bottom').addClass("bottom_To_Top");
          }
        } else {
          $("#yd_device").removeClass('top_To_Bottom').addClass("bottom_To_Top");
        }
      },
      zwDeviceOpenChange(val, oldVal) {
        if (val) {
          $("#zw_device").removeClass('bottom_To_Top').addClass("top_To_Bottom");
          if ($("#yd_device").hasClass('top_To_Bottom')) {
            this.ydDeviceOpen = false
            $("#yd_device").removeClass('top_To_Bottom').addClass("bottom_To_Top");
          }
        } else {
          $("#zw_device").removeClass('top_To_Bottom').addClass("bottom_To_Top");
        }
      },
    },
    mounted() {
      //获取本机的ip地址
      // this.initAnimation();

    }
  }
</script>

<style>
  #yd_device img {
    opacity: 0.5;
  }

  #zw_device img {
    opacity: 0.5;
  }

  #yd_device img:hover {
    opacity: 1;
  }

  #zw_device img:hover {
    opacity: 1;
  }

  .info_div span {
    color: white;
    line-height: 25px;
    font-size: 15px;
  }



  #app {
    text-align: center;
    min-width: 1450px;

  }

  #luxy {
    min-width: 1450px;
  }

  #title_container {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    height: auto;
    height: 60px;
    z-index: 999999;
  }

  #title_row {
    height: 60px;
    background-color: #000000;
    border-bottom: 3px solid #993400;
    display: flex;
    min-width: 1100px;
  }

  #tile_center {
    width: 100%;
    height: 60px;
    margin: 0px;
    padding-left: 0;
    padding-top: 20px;
  }

  #tile_center a {
    text-decoration: none;
    color: white;
  }

  #tile_center li {
    display: inline-block;
    color: white;
    border-right: 1px white solid;
    padding-right: 5%;
    padding-left: 5%;
    /* margin-right: 4%; */
    line-height: 20px;

  }

  #tile_center li:hover {
    cursor: pointer;
  }

  #tile_right {
    height: 60px;
    margin: 0px;
    padding-top: 20px;
  }

  #tile_right li {
    display: inline-block;
    color: white;
    border-right: 1px white solid;
    padding-right: 5%;
    margin-right: 4%;
    line-height: 20px;
  }

  #tile_right li:hover {
    cursor: pointer;
  }

  .footer_nav {
    text-align: left;
    height: 100%;
  }

  .footer_nav_en {
    text-align: left;
    height: 100%;
  }

  .footer_nav li {
    list-style-type: none;
    color: white;
  }

  .footer_nav_en li {
    list-style-type: none;
    color: white;
  }

  .first_li {
    font-weight: 500;
    margin-bottom: 10%;
    letter-spacing: 0.3125rem;
    font-size: 1.5rem;
    font-family: F583ee;
  }

  .first_li_en {
    font-weight: 500;
    margin-bottom: 5%;
    letter-spacing: 0.3125rem;
    font-size: 1.8rem;
    font-family: F583ee;
  }

  .other_li {
    margin-bottom: 5%;
    font-size: 1.2rem;
  }

  .other_li_en {
    margin-bottom: 3%;
    font-size: 1.4rem;
  }

  .other_li span {
    cursor: pointer;
  }

  .other_li_en span {
    cursor: pointer;
  }

  .other_li a {
    cursor: pointer;
    text-decoration: none;
    color: white;
  }

  .other_li_en a {
    cursor: pointer;
    text-decoration: none;
    color: white;
  }

  .li_parent {
    margin-bottom: 5%;
    font-size: 1.2rem;
  }

  .li_parent_en {
    margin-bottom: 3%;
    font-size: 1.2rem;
  }


  .ul_children {
    padding-left: 0;
  }

  .ul_children_en {
    padding-top: 0.5%;
    padding-left: 0;
  }

  .li_children {
    margin-bottom: 5%;
    font-size: 1.2rem;
    cursor: pointer;
    display: inline-block;
    border-right: 1px white solid;
    padding-right: 3%;
    margin-right: 2%;
  }

  .li_children_en {
    margin-bottom: 1%;
    font-size: 1.2rem;
    cursor: pointer;
    display: inline-block;
    border-right: 1px white solid;
    padding-right: 3%;
    margin-right: 2%;
  }


  .scoll {
    width: 100%;
    height: 150px;
    background-color: #1a1a1a;
    position: absolute;
    z-index: 9999;
    top: -90px
  }

  .scoll img {
    height: 100%;
    cursor: pointer;
  }


  .top_To_Bottom {
    animation: topToBottom .3s;
    -ms-animation: topToBottom .3s;
    -o-animation: topToBottom .3s;
    -webkit-animation: topToBottom .3s;
    -moz-animation: topToBottom .3s;
    -ms-animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    -ms-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .bottom_To_Top {
    animation: bottomToTop .3s;
    -ms-animation: bottomToTop .3s;
    -o-animation: bottomToTop .3s;
    -webkit-animation: bottomToTop .3s;
    -moz-animation: bottomToTop .3s;
    -ms-animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    -ms-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .index_footer_luokuan {
    opacity: 0.7;
    font-size: 13px;
    color: white;
  }

  #record_id {
    cursor: pointer;
    color: white;
    text-decoration: none;
  }

  #record_id:hover {
    opacity: 1;
    color: white;
    text-decoration: none;
  }

  #record_id:active{
    color: white;
    opacity: 1;
    text-decoration: none;
  }

  a,a:hover,a:active,a:visited,a:link,a:focus{
  　　-webkit-tap-highlight-color:rgba(0,0,0,0);
  }

  @keyframes topToBottom {
    0% {
      top: -90px;
    }

    5% {
      top: -85px;
    }

    10% {
      top: -80px;
    }

    15% {
      top: -75px;
    }

    20% {
      top: -70px;
    }

    25% {
      top: -65px;
    }

    30% {
      top: -60px;
    }

    35% {
      top: -50px;
    }

    40% {
      top: -40px;
    }

    45% {
      top: -30px;
    }

    50% {
      top: -20px;
    }

    55% {
      top: -10px;
    }

    60% {
      top: 0px;
    }

    65% {
      top: 10px;
    }

    70% {
      top: 20px;
    }

    75% {
      top: 30px;
    }

    80% {
      top: 35px;
    }

    85% {
      top: 40px;
    }

    90% {
      top: 50px;
    }

    95% {
      top: 55px;
    }

    100% {
      top: 60px;
    }
  }

  /*Safari 和 Chrome:*/
  @-webkit-keyframes topToBottom {
    0% {
      top: -90px;
    }

    5% {
      top: -85px;
    }

    10% {
      top: -80px;
    }

    15% {
      top: -75px;
    }

    20% {
      top: -70px;
    }

    25% {
      top: -65px;
    }

    30% {
      top: -60px;
    }

    35% {
      top: -50px;
    }

    40% {
      top: -40px;
    }

    45% {
      top: -30px;
    }

    50% {
      top: -20px;
    }

    55% {
      top: -10px;
    }

    60% {
      top: 0px;
    }

    65% {
      top: 10px;
    }

    70% {
      top: 20px;
    }

    75% {
      top: 30px;
    }

    80% {
      top: 35px;
    }

    85% {
      top: 40px;
    }

    90% {
      top: 50px;
    }

    95% {
      top: 55px;
    }

    100% {
      top: 60px;
    }
  }

  @keyframes bottomToTop {
    0% {
      top: 55px;
    }

    5% {
      top: 45px;
    }

    10% {
      top: 40px;
    }

    15% {
      top: 30px;
    }

    20% {
      top: 20px;
    }

    25% {
      top: 25px;
    }

    30% {
      top: 15px;
    }

    35% {
      top: 5px;
    }

    40% {
      top: -5px;
    }

    45% {
      top: -15px;
    }

    50% {
      top: -25px;
    }

    55% {
      top: -30px;
    }

    60% {
      top: -35px;
    }

    65% {
      top: -40px;
    }

    70% {
      top: -45px;
    }

    75% {
      top: -50px;
    }

    80% {
      top: -60px;
    }

    85% {
      top: -65px;
    }

    90% {
      top: -70px;
    }

    95% {
      top: -80px;
    }

    100% {
      top: -90px;
    }
  }

  /*Safari 和 Chrome:*/
  @-webkit-keyframes bottomToTop {
    0% {
      top: 55px;
    }

    5% {
      top: 45px;
    }

    10% {
      top: 40px;
    }

    15% {
      top: 30px;
    }

    20% {
      top: 20px;
    }

    25% {
      top: 25px;
    }

    30% {
      top: 15px;
    }

    35% {
      top: 5px;
    }

    40% {
      top: -5px;
    }

    45% {
      top: -15px;
    }

    50% {
      top: -25px;
    }

    55% {
      top: -30px;
    }

    60% {
      top: -35px;
    }

    65% {
      top: -40px;
    }

    70% {
      top: -45px;
    }

    75% {
      top: -50px;
    }

    80% {
      top: -60px;
    }

    85% {
      top: -65px;
    }

    90% {
      top: -70px;
    }

    95% {
      top: -80px;
    }

    100% {
      top: -90px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue